import styled from 'styled-components'
import ReactMarkdown from 'react-markdown'
import { Typography } from 'common/typography'

const ProjectRequirementsStyled = styled.div`
  margin-block-start: 2.5rem;
  .requirement-container {
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    margin-block-start: 1.5rem;
  }
  .requirements-title {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    margin-block-end: .5rem;
  }
  .requirements {
    &.junior {
      ul:before, li:before {
        background: #2FCBFF;
      }
    }
    &.mid {
      ul:before, li:before {
        background: #28FEA4;
      }
    }
    &.senior {
      ul:before, li:before {
        background: #FF3E61;
      }
    }
  }
  .requirement-badge {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    &.junior {
      background: #2FCBFF;
    }
    &.mid {
      background: #28FEA4;
    }
    &.senior {
      background: #FF3E61;
    }
  }
  .requirements-body {
    a {
      color: var(--turquoise);
      text-decoration: underline;
    }
    ul {
      padding-inline-start: 2.25rem;
      position: relative;
      li {
        position: relative;
        margin: 1rem 0;
        &:before {
          top: 4px;
          left: -1.5rem;
          content: "";
          position: absolute;
          border: 1px solid var(--white);
          border-radius: 50%;
          width: .5rem;
          height: .5rem;
        }
        &:first-of-type {
          margin: .5rem 0;
        }
        &:last-of-type {
          margin: .5rem 0;
        }
      }
      &:before {
        /* z-index: -; */
        top: -1rem;
        bottom: .35rem;
        left: 1rem;
        content: "";
        position: absolute;
        width: 2px;
      }
    }
  }
  @media (min-width: 1024px) {
    .requirement-container {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
    }
  }
`

function RequirementList({ level, requirements }) {
  return (
    <div className={`requirements ${level.toLowerCase()}`}>
      <div className="requirements-title">
        <div className={`requirement-badge ${level.toLowerCase()}`}>
          <img src="/images/projects/lap-icon.png" alt="Icono de una laptop" width="23" height="15" />
        </div>
        <Typography font="regularBold">{level}</Typography>
      </div>
      <div className="requirements-body">
        <ReactMarkdown>
          {requirements.replace('//n')}
        </ReactMarkdown>
      </div>
    </div>
  )
}

function ProjectRequirements({ junior, mid, senior }) {
  return (
    <ProjectRequirementsStyled>
      <Typography font="regularBold">Criterios de aceptación</Typography>
      <div className="requirement-container">
        {junior ? (
          <RequirementList level="Junior" requirements={junior} />
        ) : null}
        {mid ? (
          <RequirementList level="Mid" requirements={mid} />
        ) : null}
        {senior ? (
          <RequirementList level="Senior" requirements={senior} />
        ) : null}
      </div>
    </ProjectRequirementsStyled>
  )
}

export default ProjectRequirements
